<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Categories
        <small>List of categories</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Categories</li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Filter Category</h3>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: hidden;">
          <div class="form-group">
            <label for="name">
              Name
            </label>

            <input type="text"
              class="form-control"
              id="name"
              placeholder="Search by name here"
              v-model="params.name"
              @keyup="onInput">
          </div>
        </div>
      </div>

      <div class="box">
        <div class="box-header">
          <a class="btn btn-success pull-right"
            @click.prevent="add">
            Add New Category
          </a>
        </div>

        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
                <th class="text-center">Image</th>
                <th>Action(s)</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="!categories" key="empty">
                <td colspan="5">
                  <strong>Result not found</strong>
                </td>
              </tr>
              <tr v-for="category in categories" v-else>
                <td>{{ category.name }}</td>
                <td>{{ category.slug }}</td>
                <td class="text-center">
                  <img
                    v-if="category.image_url && category.image_url != ''"
                    :src="parseImage(category.image_url, '_thumb')"
                    style="width: 64px;" />
                </td>
                <td>
                  <a class="btn btn-primary btn-xs"
                    @click.prevent="edit(category.id)">
                    Edit
                  </a>
                  <a class="btn btn-danger btn-xs"
                    @click.prevent="remove(category)">
                    Delete
                  </a>
                  <div v-if="error" class="alert alert-danger">
                    <a class="close"
                      @click="error = false">
                      &times;
                    </a>
                    {{ error }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'CategoryIndex',

  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      categories: [],
      pagination: {},
      error: null,

      params: {
        name: null,
      },
    };
  },

  methods: {
    fetch(page) {
      const pageQuery = this.$route.query.page;
      this.params.page = page || pageQuery;

      this.axios.get('/categories', {
          params: this.params,
          responseType: this.type,
        })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            this.categories = null;
            this.pagination = {};
            return;
          }

          this.categories = data;
          this.pagination = meta.pagination;
        });

      if (page) {
        window.history.pushState(`Categories page: ${page}`, null, `/categories?page=${page}`);
      }
    },

    onInput: debounce(function debouncedInput() {
      this.fetch();
    }, 500),

    changePage(page) {
      this.fetch(page);
    },

    add() {
      this.$router.push({
        name: 'category-create',
      });
    },

    edit(id) {
      this.$router.push({
        name: 'category-edit',
        params: {
          id,
        },
      });
    },

    delete(category) {
      this.axios.delete(`/categories/${category.id}`)
        .then(() => {
          this.fetch();

          this.$swal({
            title: 'Deleted',
            text: `${category.name} has been deleted.`,
            type: 'success',
            timer: 3000,
          });
        })
        .catch((error) => {
          if (error.response) {
            this.$swal({
              title: 'Failed',
              text: `Oppss! You can't delete "${category.name}" because this category still used by the product`,
              type: 'error',
              timer: 8000,
            });
          }
        });
    },

    remove(category) {
      this.$swal({
        title: 'Deleting Category',
        text: `Are you sure you want to delete ${category.name}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.value) {
          this.delete(category);
        } else {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000,
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000,
          });
        }
      });
    },
  },

  created() {
    this.fetch();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/categories/Index.vue